module.exports = __webpack_public_path__ + "img/logo-MeetingHub.47dc6ccc.png";